import { PAGE_DEFAULT, ROW_DEFAULT } from 'constants/global';

export const EMPTY_DATA_SEARCH_CONTRACT_LABOR_CONFIRM = {
    text_search: '',
    status: null,
    contract_type_uuid: null,
    linked_type: null,
    is_conversion: null,
    from_date: null,
    to_date: null,
    created_by: null,
    row: ROW_DEFAULT,
    page: PAGE_DEFAULT,
};
